import {
  Button,
  AppBar,
  Toolbar,
  Typography,
  Box,
  Drawer,
  Container,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider,
} from "@mui/material"
import MenuIcon from "@mui/icons-material/Menu"
import PostAddIcon from "@mui/icons-material/PostAdd"
import { useContext, useState } from "react"
import { useNavigate } from "react-router-dom"
import { UserContext } from "../providers/userProvider"

const NavBar = () => {
  const { user, handleLogout } = useContext(UserContext)
  const [menuOpen, setMenuOpen] = useState(false)
  const [infoOpen, setInfoOpen] = useState(false)
  const navigate = useNavigate()

  const navTo = (path) => {
    setMenuOpen(false)
    navigate(path)
  }

  const logout = () => {
    setMenuOpen(false)
    handleLogout()
    navigate("/login")
  }

  const loggedInLinks = [
    { label: "Home", action: () => navTo("/") },
    { label: "Calendar", action: () => navTo("/calendar") },
    { label: "Settings", action: () => navTo("/settings") },
    { label: "Logout", action: logout },
  ]

  const loggedOutLinks = [
    { label: "Home", action: () => navTo("/") },
    { label: "Login", action: () => navTo("/login") },
  ]

  const links = user.phoneNumber ? loggedInLinks : loggedOutLinks

  const desktopButtons = () => (
    <Box sx={{ display: { xs: "none", sm: "flex" }, alignItems: "center" }}>
      {user.phoneNumber ? (
        <>
          <Button sx={{ mx: 0.5 }} variant="contained" size="small" onClick={() => navTo("/")}>Home</Button>
          <Button sx={{ mx: 0.5 }} variant="contained" size="small" onClick={() => navTo("/calendar")}>Calendar</Button>
          <Button sx={{ mx: 0.5 }} variant="contained" size="small" onClick={() => navTo("/settings")}>Settings</Button>
          <Button sx={{ mx: 0.5 }} variant="contained" size="small" onClick={logout}>Logout</Button>
        </>
      ) : (
        <>
          <Button sx={{ mx: 0.5 }} variant="contained" size="small" onClick={() => navTo("/")}>Home</Button>
          <Button sx={{ mx: 0.5 }} variant="contained" size="small" onClick={() => setInfoOpen(true)}><PostAddIcon /></Button>
          <Button sx={{ mx: 0.5 }} variant="contained" size="small" onClick={() => navTo("/login")}>Login</Button>
        </>
      )}
    </Box>
  )

  const mobileHamburger = () => (
    <IconButton
      sx={{ display: { xs: "flex", sm: "none" }, color: "inherit" }}
      onClick={() => setMenuOpen(true)}
    >
      <MenuIcon />
    </IconButton>
  )

  return (
    <>
      <AppBar position="sticky" color="primary" sx={{ top: 0 }}>
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography>Whitesides Family Blog</Typography>
          {desktopButtons()}
          {mobileHamburger()}
        </Toolbar>
      </AppBar>

      {/* Mobile nav drawer */}
      <Drawer anchor="right" open={menuOpen} onClose={() => setMenuOpen(false)}>
        <Box sx={{ width: 220, pt: 2 }}>
          <List>
            {links.map(({ label, action }) => (
              <ListItem key={label} disablePadding>
                <ListItemButton onClick={action}>
                  <ListItemText primary={label} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
          {!user.phoneNumber && (
            <>
              <Divider />
              <List>
                <ListItem disablePadding>
                  <ListItemButton onClick={() => { setMenuOpen(false); setInfoOpen(true); }}>
                    <ListItemText primary="How to post?" />
                  </ListItemButton>
                </ListItem>
              </List>
            </>
          )}
        </Box>
      </Drawer>

      {/* How-to-post info drawer (logged-out users) */}
      <Drawer anchor="top" open={infoOpen} onClose={() => setInfoOpen(false)}>
        <Container sx={{ py: 3 }}>
          <Typography variant="h6" gutterBottom>How do I add a post?</Typography>
          <Typography variant="body1">
            Glad you asked. <br /><br />
            Simply text your blog entry to 1 (208) 670-8375. Refresh the blog and wa-la! You've just posted your first blog entry! <br /><br />
            You are able to post text and photos to the blog. It's recommend that you only post 1-2 photos for every entry to keep the blog legible.<br /><br />
            When you send a photo, it's important to note that you send the picture and text in <strong>the same message</strong>.
            If you don't your blog post will get split into 2 different posts. One for your picture and one for your message. <br /><br />
            Enjoy!
          </Typography>
          <Button sx={{ mt: 2 }} onClick={() => setInfoOpen(false)}>Close</Button>
        </Container>
      </Drawer>
    </>
  )
}

export default NavBar
